import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import GetUserInfoService from "../../../../../service/GetUserInfoService";
import localeText from "../../../../../locale";
import { computeDistanceKm } from "./distanceUtils";

const getUserInfoService = new GetUserInfoService();

const PartnerDetailOverlay = ({ partner, userCenter, onClose }) => {
  const [shopTitle, setShopTitle] = useState(null);
  const [shopLoading, setShopLoading] = useState(true);
  const [shopAddress, setShopAddress] = useState(null);

  useEffect(() => {
    if (!partner?.username) {
      setShopLoading(false);
      return;
    }
    let cancelled = false;
    setShopLoading(true);
    getUserInfoService
      .getUserShop(partner.username)
      .then((res) => {
        if (cancelled) return;
        if (res?.messageCode === 200001 && res?.result?.shopConfiguration) {
          const conf = res.result.shopConfiguration;
          setShopTitle(conf.title || partner.username);
          const u = res.result?.user;
          if (u && (u.address || u.city || u.country)) {
            const parts = [u.address, u.number, u.city, u.state, u.country].filter(Boolean);
            setShopAddress(parts.join(", "));
          }
        } else {
          setShopTitle(partner.username);
        }
      })
      .catch(() => {
        if (!cancelled) setShopTitle(partner.username);
      })
      .finally(() => {
        if (!cancelled) setShopLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [partner?.username]);

  const displayName = shopLoading ? partner?.username : shopTitle || partner?.username;
  const email = partner?.userEmail || partner?.user?.email || "";
  const activities = partner?.activities || [];
  const rawDistanceKm =
    userCenter?.lat != null && userCenter?.lng != null
      ? computeDistanceKm(userCenter, partner)
      : null;
  const distanceKm =
    rawDistanceKm != null && Number.isFinite(rawDistanceKm) ? Math.round(rawDistanceKm) : null;

  const directionsUrl =
    partner?.latitude != null && partner?.longitude != null
      ? `https://www.google.com/maps/dir/?api=1&destination=${partner.latitude},${partner.longitude}`
      : null;
  const mailto = email ? `mailto:${email}` : null;

  return (
    <div
      className="partner-detail-overlay flex flex-column"
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        width: "100%",
        maxWidth: "400px",
        height: "100%",
        backgroundColor: "var(--theme-background, #fff)",
        borderLeft: "1px solid var(--theme-border, #eaeaea)",
        boxShadow: "-4px 0 12px rgba(0,0,0,0.1)",
        zIndex: 1100,
        overflowY: "auto",
        padding: "1rem",
      }}
    >
      <div className="flex justify-content-between align-items-start mb-3">
        <h2 className="text-lg font-semibold m-0" style={{ color: "var(--theme-text, #171717)" }}>
          {displayName}
        </h2>
        <Button
          icon="pi pi-times"
          className="p-button-text p-button-rounded"
          onClick={onClose}
          aria-label={localeText("closeAction")}
        />
      </div>
      {distanceKm != null && (
        <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
          {localeText("partnerB2bDistanceFromYou")?.replace("{km}", distanceKm) ||
            `${distanceKm} km da sua posição`}
        </p>
      )}
      {shopAddress && (
        <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
          {shopAddress}
        </p>
      )}
      {email && (
        <p className="text-sm m-0 mb-2">
          <span style={{ color: "var(--theme-text-muted, #5C5C5C)" }}>
            {localeText("partnerB2bContact")}:{" "}
          </span>
          <a href={mailto} style={{ color: "var(--theme-primary, #1DAF61)" }}>
            {email}
          </a>
        </p>
      )}
      {activities.length > 0 && (
        <div className="mb-3">
          <div
            className="text-sm font-semibold mb-1"
            style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
          >
            {localeText("partnerB2bActivities")}
          </div>
          <ul className="m-0 pl-3" style={{ color: "var(--theme-text, #171717)" }}>
            {activities.map((a, i) => (
              <li key={i} className="text-sm mb-1">
                {a.activityDescription || a.customDescription || a.atecoCode || ""}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="flex flex-column gap-2 mt-3 justify-content-end flex-1">
        {mailto && (
          <Button
            label={localeText("partnerB2bContactPartner")}
            icon="pi pi-envelope"
            className="border-none w-full border-round-md p-no-outline"
            style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff" }}
            onClick={() => window.open(mailto)}
          />
        )}
        <Button
          label={localeText("store")}
          icon="pi pi-shop"
          className="border-none w-full border-round-md p-no-outline"
          style={{ backgroundColor: "var(--theme-primary, #1DAF61)", color: "#fff" }}
          onClick={() => window.open(`/store?user=${partner.username}`, "_blank")}
        />
        {directionsUrl && (
          <Button
            label={localeText("partnerB2bGetDirections")}
            icon="pi pi-map-marker"
            className="p-button-outlined w-full border-round-md p-no-outline"
            style={{
              borderColor: "var(--theme-primary, #1DAF61)",
              color: "var(--theme-primary, #1DAF61)",
            }}
            onClick={() => window.open(directionsUrl, "_blank")}
          />
        )}
      </div>
    </div>
  );
};

export default PartnerDetailOverlay;
